<template>
  <div class="registerform__step step__three">
    <div class="step__content">
      <div class="progress-bar">
        <Progressbar
        :active="3"
        @updateStep="updateStep($event)"></Progressbar>
      </div>
      <form class="step__form">
        <div class="form__headline">
          <h4 class="-color-alpha">Ihre Kontaktdaten:</h4>
        </div>
        <div class="form__form">
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <CmInputTypeSelect
                label="Anrede"
                :bold="true"
                identifier="salutation"
                v-model="registerform.contact.salutation"
                :options="salutationOptions"
                :error="error && salutationIsMissing"></CmInputTypeSelect>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="Vorname*"
                :bold="true"
                identifier="firstname"
                v-model="registerform.contact.firstname"
                :error="error && firstnameIsMissing"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Nachname*"
                :bold="true"
                identifier="lastname"
                v-model="registerform.contact.lastname"
                :error="error && lastnameIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one" v-if="registerform.state === 2">
              <TextInput
                label="Firma*"
                :bold="true"
                identifier="company"
                v-model="registerform.contact.company"
                :error="error && companyIsMissing && registerform.state === 2"></TextInput>
            </div>
            <div class="col col-one" v-else>
              <TextInput
                label="Firma"
                :bold="true"
                identifier="company"
                v-model="registerform.contact.company"
                :error="error && companyIsMissing && registerform.state === 2"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="PLZ"
                :bold="true"
                identifier="zip"
                v-model="registerform.contact.zip"
                :error="false"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Ort"
                :bold="true"
                identifier="city"
                v-model="registerform.contact.city"
                :error="false"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="E-Mail*"
                :bold="true"
                identifier="email"
                v-model="registerform.contact.email"
                :error="error && emailIsMissing"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Telefonnummer*"
                :bold="true"
                identifier="phone"
                v-model="registerform.contact.phone"
                :error="error && phoneIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--one-col -smaller-spacing">
            <div class="col">
              <TextInput
                  label="Wann sind Sie am besten erreichbar?"
                  :bold="true"
                  identifier="availability"
                  v-model="registerform.contact.availability"
                  :error="error && availabilityIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap -smaller-spacing -privacy">
            <div class="col">
              <Checkbox
                identifier="privacy"
                v-model="registerform.contact.privacy"
                @updateValue="registerform.contact.privacy = $event"
                :error="error && privacyIsMissing"><span>Mit Setzen des Hakens erkläre ich mich einverstanden, dass die von mir erhobenen Daten für die Bearbeitung meiner Anfrage elektronisch erhoben und gespeichert werden. Diese Einwilligung kann jederzeit mit einer Nachricht an uns widerrufen werden. Weitere Informationen entnehmen Sie der <a :href="privacyPage" target="_blank">Datenschutzerklärung</a>.*</span></Checkbox>
            </div>
          </div>
        </div>
        <div class="form__action">
          <div class="-btn-alpha" @click="nextStep()"><span>Absenden</span></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Progressbar from '../Progressbar.vue'
import TextInput from '../form/CmInputTypeText.vue'
import Checkbox from '../form/CmInputTypeCheckbox.vue'
import CmInputTypeSelect from "@/components/form/CmInputTypeSelect";
export default {
  name: 'StepThree',
  props: ['registerform', 'privacyPage'],
  data () {
    return {
      error: false,
      salutationOptions: [
        {
          label: 'Herr',
          value: 'Herr'
        },
        {
          label: 'Frau',
          value: 'Frau'
        }
      ]
    }
  },
  components: {
    CmInputTypeSelect,
    Progressbar,
    TextInput,
    Checkbox
  },
  computed: {
    firstnameIsMissing: function () {
      return !this.registerform.contact.firstname
    },
    lastnameIsMissing: function () {
      return !this.registerform.contact.lastname
    },
    emailIsMissing: function () {
      return !this.registerform.contact.email
    },
    phoneIsMissing: function () {
      return !this.registerform.contact.phone
    },
    privacyIsMissing: function () {
      return !this.registerform.contact.privacy
    },
    companyIsMissing: function () {
      return !this.registerform.contact.company
    },
    salutationIsMissing: function () {
      return !this.registerform.contact.salutation
    },
    availabilityIsMissing: function () {
      return !this.registerform.contact.availability
    },
    allFieldsFilled: function () {
      return !this.firstnameIsMissing && !this.lastnameIsMissing && !this.emailIsMissing && !this.phoneIsMissing && !this.privacyIsMissing && !this.salutationIsMissing && !this.availabilityIsMissing
    },
    allFieldsFilledForStateTwo: function () {
      return !this.companyIsMissing && !this.firstnameIsMissing && !this.lastnameIsMissing && !this.emailIsMissing && !this.phoneIsMissing && !this.privacyIsMissing && !this.salutationIsMissing && !this.availabilityIsMissing
    }
  },
  methods: {
    updateStep: function (num) {
      switch (num) {
        case 1:
          this.$emit('updateStep', 'StepOne')
          break
        case 2:
          this.$emit('updateStep', 'StepTwo')
          break
        case 3:
          this.$emit('updateStep', 'StepThree')
          break
      }
    },
    updateVehicleCount: function (diff) {
      if (this.registerform.vehicleCount + diff !== 0) {
        this.registerform.vehicleCount = this.registerform.vehicleCount + diff
      }
    },
    nextStep: function () {
      if (this.registerform.state === 2) {
        if (this.allFieldsFilledForStateTwo) {
          this.error = false
          this.$emit('handleRequest', this.registerform)
        } else {
          this.error = true
        }
      } else {
        if (this.allFieldsFilled) {
          this.error = false
          this.$emit('handleRequest', this.registerform)
        } else {
          this.error = true
        }
      }

    }
  }
}
</script>
